/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef, useState } from "react"
import Slider from "react-slick"

// Import css files
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Play } from "lucide-react";
import VideoModal from "./video-modal";

interface Thumbnail {
  url: string; // URL of the thumbnail image
};

interface Video {
  id: string;            // Unique identifier for the video
  MediaType: 'URL' | 'Upload'; // Type of media ('URL' or 'Upload')
  Url: string | null;     // URL of the video (if MediaType is 'URL')
  VideoTitle: string;     // Title of the video
  Thumbnail: Thumbnail | null; // Thumbnail object, nullable
};
  
  interface VideoSection {
    SectionTitle: string;        // Title of the section
    AddVideos: Video[];          // Array of videos
  };
  
 export interface AllStrapiVideoSection {
    nodes: VideoSection[] | null;       // Array of video sections
  };

const VideosWithModal: React.FC<AllStrapiVideoSection> = ({ nodes }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [selectedVideo, setSelectedVideo] = useState<string|null>(null)
  const [selectedTitle, setSelectedTitle] = useState<string>("Sahil CNC")
  const videoRef = useRef(null)


     // Check if nodes is undefined or empty
     if ( !nodes || nodes.length === 0) return null;

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true, // Enable auto-sliding
    autoplaySpeed: 3000, // Set the interval between slides (in milliseconds)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const {SectionTitle,AddVideos}=nodes[0];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleItemClick = (videoId: string) => {
    const video = AddVideos.find((v) => v.id === videoId);
  
    // Check if the video is found
    if (video) {
      setSelectedVideo(video.Url ?? ""); // Use an empty string or a fallback value if `Url` is null or undefined
      setSelectedTitle(video.VideoTitle ?? "Sahil CNC"); // Use fallback title if `VideoTitle` is missing
    } else {
      // Handle the case when no video is found
      setSelectedVideo(""); // Set to a default or empty string
      setSelectedTitle("Sahil CNC"); // Default title
    }
  
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    // if (videoRef.current) {
    //   videoRef.current?.pause()
    // }
    setIsModalOpen(false)
    setSelectedVideo(null)
  }



  return (
    <div className="bg-[#fff] py-6 videoContainer">
        <h2 className="text-4xl py-4 font-bold text-center whitespace-pre-wrap max-lg:text-2xl">{SectionTitle}</h2>
   
    <div className="container mx-auto px-4 ">
    
        {AddVideos.length >0?  <Slider {...settings}>
        {AddVideos.map((video) => (
          <div className="p-4" key={video.id}>
            <div
              className="bg-transparent rounded-lg shadow-md overflow-hidden cursor-pointer group relative"
              onClick={() => { handleItemClick(video.id) }}
            >
              {/* Video Thumbnail */}
              <div className="relative aspect-video">
                <img
                  alt={video.VideoTitle}
                  className="w-full h-full object-cover"
                  src={video.Thumbnail?.url || "/placeholder.svg"}
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-colors flex items-center justify-center">
                  <Play className="w-12 h-12 text-white opacity-75 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
              {/* Video Title */}
              {/* <div className="p-4 min-h-24 bg-action-btn2">
                <h3 className="text-[19px] !leading-8 font-bold text-white  mb-0">{video.VideoTitle}</h3>
              </div> */}
            </div>
          </div>
        ))}
      </Slider> : null}
      

     <VideoModal isOpen={isModalOpen} onClose={handleCloseModal} selectedVideo={selectedVideo}  videoRef = {videoRef} videoTitle={selectedTitle} />
    </div>
    </div>
  )
}

export default VideosWithModal

